<template>
  <div class="signIn" style="background:#F5F5F8;">
    <van-nav-bar
      :title="$t('m.qd_span0')"
      fixed
      placeholder
      :border="false"
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content" style="position: relative;">
      <!-- <div class="signIn_btn">
        <div class="discolor" @click="signIn">
          <img style="width: 100%;height: 100%;" :src="signInTitle=='立即签到'?img1:img2" alt="">
        </div>
      </div>
      <div class="sigIn_list_title" style="margin-top:70px;margin-bottom:10px;">
        <img style="height: 15px;width: auto;margin:0 auto;display:block;" src="../../assets/images/qianlie.png" alt="">
      </div> -->
      <!-- 签到列表 -->
      <div style="position: absolute;left:25px;top:80px;color:#fff;">
        <!-- <div style="font-size:16px;font-weight:bold;">{{$t('m.qd_span01')}}</div> -->
        <!-- <div style="font-size:13px;font-weight:bold;margin-top:5px;">{{$t('m.qd_span02')}}</div> -->
      </div>
      <div style="background:#fff;border-radius:10px;padding:20px 12px;">
        <div
          style="display:flex;align-items:center;color:#000;justify-content: center;"
        >
          <span>{{ $t("m.qd_span4") }}</span>
          <!-- <div style="font-size:16px;font-weight:600;">今日签到得2元</div>
           <div style="display:flex;align-items:center;font-size:12px;color:#333;">
             签到提醒
             <van-switch style="margin-left:8px;" v-model="checked" active-color="#FF4600" inactive-color="#EBEBEB" size="14px" />
           </div> -->
        </div>
        <div
          class="discolor"
          @click="signIn"
          :style="{
            background:
              signInTitle == $t('m.qd_span3') ? 'var(--bg-color)' : '#CCCCCC'
          }"
          style="text-align:center; width: 70%;margin:0 auto;line-height:50px;border-radius:30px;font-weight:bold;color:#fff;font-size:15px;margin-top:40px;"
        >
          <!--          {{ $t("m.qd_span3") }}-->
          {{ signInTitle }}
        </div>
        <!-- <div style="display:flex;align-items:center;color:#999;justify-content: space-between;font-size:11px; width: 85%;margin:0 auto;margin-top:20px;">
          <div><img src="../../assets/images/new/liwu.png" style="width: 10px;height: 10px;margin-right:3px;" alt="">
          <span>连续签到30天，获惊喜礼包</span>
          </div>
          <div @click="jifens()">我的积分{{jifen}}<van-icon name="arrow" size="11" color="#999999" /></div>
        </div> -->
      </div>
      <div
        style="background:#fff;border-radius:10px;padding:15px 12px ;margin-top:10px;display:flex;align-items:center;"
      >
        <div
          style="width: 40px;height: 40px;background:#FFECE7;border-radius:50%;"
        >
          <img
            src="../../assets/images/new/yaoqing.png"
            style="width: 30px;height: 30px;margin:5px;"
            alt=""
          />
        </div>
        <span
          style="color:#000;font-weight:bold;font-size:14px;flex:1;margin-left:8px;"
          >{{ $t("m.qd_span6") }}</span
        >
        <div
          @click="yaoqing()"
          style="background:var(--bg-color);text-align:center; width: 80px;margin:0 auto;line-height:30px;border-radius:20px;color:#fff;font-size:12px;"
        >
          立即邀请
        </div>
      </div>
      <div
        class="signIn_list"
        style="background:#FFF6F0;margin-top:10px;padding:15px 12px;border-radius:10px;"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            style="font-size:16px;font-weight:600;margin-bottom:10px;color:var(--bg-color);"
          >
            {{ $t("m.qd_span8") }}
          </div>
          <div class="item" v-for="(item, index) in signInList" :key="index">
            <div
              style="border:1px solid #FF8A3E;width: 40px;height: 40px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#fff;margin-right:12px;"
            >
              <img
                src="../../assets/images/new/renwus.png"
                style="width: 20px;height: 20px;"
                alt=""
              />
            </div>
            <div class="divs">
              <span style="fint-size:14px;font-weight:bold;color:#444;">
                {{ $t("m.qd_span9") }}
              </span>
              <span>{{ item.created_at }}</span>
            </div>
            <div
              class="divs1"
              style="font-size:20px;font-weight:bold;color:#FF8A3E;"
            >
              <span>&#43;</span>
              <span>{{ item.integral }}</span>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";
export default {
  name: "",
  data() {
    return {
      checked: true,
      img1: require("../../assets/images/ljqd.png"),
      img2: require("../../assets/images/yiqian.png"),
      signInTitle: "立即签到",
      signInList: [],
      loading: false,
      finished: false,
      refreshing: false,
      jifen: 0,
      userInfo: {},
      page: 0
    };
  },
  created() {
    let that = this;
    setTimeout(function() {
      getMyUserInfo().then(res => {
        let userInfo = res.data.data;
        if (userInfo.is_auth != 1) {
          that.$dialog.message("请先完成实名认证");
          that.$router.push({ name: "memmber_business" });
        }
      });
    }, 500);
    setTimeout(function() {
      that.status();
    }, 1000);
    setTimeout(function() {
      request
        .post("/user/user/index", {}, { login: true })
        .then(res => {
          that.jifen = res.data.data.integral;
        })
        .catch(err => {
          that.$dialog.error(err.response.data.msg);
        });
    }, 2000);
  },
  methods: {
    yaoqing() {
      this.$router.push({
        path: "/invitation"
      });
    },
    jifens() {
      this.$router.push({
        path: "/JfList"
      });
    },
    async signIn() {
      if (this.signInTitle === "今日已签到") {
        return;
      }
      this.signInTitle = "今日已签到";
      request
        .get("/shop/sign/add", {}, { login: true })
        .then(res => {
          console.log("签到");
          console.log(res);
          this.$dialog.success("签到成功");
          this.$router.go(0);
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    async status() {
      request
        .get("/shop/sign/status", {}, { login: true })
        .then(res => {
          console.log("签到");
          console.log(res);
          if (res.data.data.status == 1) {
            this.signInTitle = "今日已签到";
          }
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;
      request
        .get("/shop/sign/log", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.length; i++) {
            this.signInList.push({
              id: res.data.data[i]["id"],
              created_at: res.data.data[i]["created_at"],
              title: res.data.data[i]["id"],
              integral: res.data.data[i]["integral"]
            });
          }
          this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          console.log(err);
          this.$dialog.error(err.response.data.msg);
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onRefresh() {
      this.page = 0;
      this.list = [];
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      this.loading = true;
      // this.onLoad();
    }
  },
  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
@import "../../assets/css/signIn.less";
html,
body {
  background: #fff !important;
}
.discolor:active {
  opacity: 0.3 !important;
}
</style>
